
import FileButton from "./fileButton";
import ExportPDF from "./exportPDF";
import "./style.css";
import { useLocation } from "react-router-dom";
const Index = ({ getFunction, headers, excelHeaders, queryString }) => {
    const location = useLocation();
    const formattedUrl = location.pathname.replace('/', '').replace(/-/g, '_').replace(/\//g, '_');
    return (
        <div className="row margin-b">
            <div className="col-sm-12 col-md-6">
                <div className="dt-buttons btn-group">
                    <ExportPDF getFunction={getFunction} headers={headers} queryString={queryString} />
                    <FileButton getFunction={getFunction} headers={excelHeaders} queryString={queryString} tableName={formattedUrl} />
                </div>
            </div>
        </div>
    )
}
export default Index